(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewRiskController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', 'riskSelfAssessmentReviewService', 'govProcess', 'criterias', 'riskToReview'];

    function Controller($rootScope, $scope, $state, riskSelfAssessmentReviewService, govProcess, criterias, riskToReview) {
        $scope.govProcess           = govProcess;
        $scope.riskToReview         = riskToReview;
      
        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.isReadOnly = $scope.riskToReview.Assessment.HasFinalAssessorReviewed;
        $scope.ctrlCtxt.criterias = criterias;

        if ($scope.riskToReview.Risk && $scope.riskToReview.Risk.RiskID) {
            riskSelfAssessmentReviewService.getRiskEvents($scope.riskToReview.Risk).then(function (riskEvents) {
                $scope.riskEvents = riskEvents;
                if (_.size(riskEvents) > 0) {
                    $scope.riskEventCssIcon = riskEvents[0].ItemCssIcon;
                }
            });
        }

        initAssessmentIndicators();

        // Page is dirty
        $scope.pageIsDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $scope.ctrlCtxt.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Review 
        $scope.review = function () {
           $scope.ctrlCtxt.isSaving = true;

            if ($scope.hasAssessmentBeenModified()) {
                $scope.riskToReview.Assessment.InitialIndicatorsConfirmedAsIs = false;
            }

            return riskSelfAssessmentReviewService
                .reviewRiskByAssessor($scope.riskToReview)
                .then(function (riskToReview) {
                   $scope.riskToReview = riskToReview;
                   $scope.ctrlCtxt.isReadOnly  = $scope.riskToReview.Assessment.HasFinalAssessorReviewed;
                   $scope.ctrlCtxt.isSaving    = false;
                });
        };

        // Is review action disabled?
        $scope.isReviewActionDisabled = function () {
            return $scope.form.$invalid ||$scope.ctrlCtxt.isSaving;
        };

        // Have assessement been modified?
        $scope.hasAssessmentBeenModified = function () {
            return $scope.ctrlCtxt.needSaveChange || $scope.ctrlCtxt.haveRatingsBeenModified;
        };

        // Cancel Review
        $scope.cancelReview = function () {
            return riskSelfAssessmentReviewService
                    .cancelReviewRisk($scope.riskToReview)
                    .then(function (riskToReview) {
                       $scope.ctrlCtxt.isReadOnly = false;
                    });
        };

        // Go back
        $scope.goBack = function () {
            $state.go('home');
        };

        // Helpers
        function getSelectedRating(ratingCode, ratings) {
            return _.find(ratings, { Code: ratingCode });
        }

        function initAssessmentIndicators() {
            if ($scope.riskToReview.Assessment.InitialIndicatorsConfirmedAsIs === false) return;

            $scope.riskToReview.Assessment.FinalIsAccurate =
                 $scope.riskToReview.Assessment.InitialIsAccurate;

            $scope.riskToReview.Assessment.FinalRiskNameChange =
                $scope.riskToReview.Assessment.InitialProposedRiskNameChange;

            $scope.riskToReview.Assessment.FinalRiskDescriptionChange =
                    $scope.riskToReview.Assessment.InitialProposedRiskDescriptionChange;
        }
    }
})();